// eslint-disable-next-line no-restricted-imports
import { useDebouncedCallback } from 'use-debounce';
import { DebouncedState } from 'use-debounce/dist/useDebouncedCallback';

type AnyFunction = (...args: any) => any;
export type DebouncedFunc<Func extends AnyFunction> = DebouncedState<Func>;

export const useDebounce = useDebouncedCallback;
